import { render, staticRenderFns } from "./viaggia-con-noi.vue?vue&type=template&id=436e3cc7&"
import script from "./viaggia-con-noi.vue?vue&type=script&lang=js&"
export * from "./viaggia-con-noi.vue?vue&type=script&lang=js&"
import style0 from "./viaggia-con-noi.vue?vue&type=style&index=0&id=436e3cc7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports